import { Search } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconSearch12Line = createIcon(Search, 12, "Line");
export const IconSearch16Line = createIcon(Search, 16, "Line");
export const IconSearch20Line = createIcon(Search, 20, "Line");
export const IconSearch24Line = createIcon(Search, 24, "Line");
export const IconSearch32Line = createIcon(Search, 32, "Line");
export const IconSearch48Line = createIcon(Search, 48, "Line");
export const IconSearch64Line = createIcon(Search, 64, "Line");
